var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routeStatus === 200)?_c('keep-alive',{attrs:{"include":_vm.keepAlivePages}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }